<div *appFeatureFlag="'isPricingTableAvailable'" class="row mt-3">
  <div class="row d-lg-flex justify-content-center d-block mx-0 row-cols-1 flex-nowrap" [ngClass]="{
      'row-cols-lg-4': isDashboard,
      'row-cols-lg-3': !isDashboard
    }">
    <!-- main plan card mobile view -->
    <app-main-plan-card *ngIf="identiAlertAvailable && showWideIdentiAlertCard"
      class="main-plan-card mb-4 identialert-mobilview" [content]="mainPlanContent" [hideIcon]="hideIcons"
      [userCurrentProductType]="userCurrentProductType" [user]="user" [petName]="petName" [petType]="petType"
      [thereIsOnlyOneCat]="thereIsOnlyOneCat" [isOutdoors]="isOutdoors">
    </app-main-plan-card>

    <ng-container *appFeatureFlag="'isPetProtectionServicesAvailable'">
      <!--identibase+-->
      <ng-container *appFeatureFlag="'isIdentiPlusAvailable'">
        <div *ngIf="identibasePlusAvailable" class="col mb-4 text-center identibaseplus-price-card-wrapper">
          <app-price-card
            [viewOnly]="viewOnly"
            [showShortDescription]="showShortDescription"
            [showInfoLine]="showInfoLine"
            [showFeatures]="appPriceCardFeatureText ? true : showFeatures"
            [buttonLabel]="buttonLabel"
            [hidePrices]="hidePrices"
            [disabled]="disabled"
            [showPeachBanner]="showPeachBanner"
            [planId]="pricingPlans.identibasePlus"
            [userCurrentProductType]="userCurrentProductType"
            [hideIcon]="hideIcons"
            [hasBuyNow]="hasBuyNow"
            [highlighted]="false"
            [hidePlusFromSubtitle]="true"
            imageUri="/assets/images/pricingTable/identibasePlus.svg"
            planTitle="{{ plan1Name }}"
            yearlyPrice="{{ plan1YearlyPrice }}"
            [planLongSubtitle]="appPriceCardFeatureText ? 'Secure &amp; up to date details' : 'For less than ' + plan1DailyPrice + ' per day, activate your pet\'s Digital ID with:'"
            [features]="appPriceCardFeatureText ? appPriceCardFeatureText : getFeaturesFor(planFeatureService.plan1Name)"
            [descriptionList]="appPriceCardFeatureText"
            [shortDescriptionList]="plan1BenefitsShort"
            [description]="appPriceCardFeatureText ? '' : 'Get your missing pet home more quickly by activating your pet’s Digital ID. And, with identibase+, keep the Digital ID up to date withunlimited changes to your details.'"
            (onSelect)="select($event)"
            (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS)">
          </app-price-card>
        </div>
      </ng-container>

      <!--Identialert-->
      <ng-container *appFeatureFlag="'isIdentialertAvailable'">
        <div *ngIf="identiAlertAvailable && !showWideIdentiAlertCard" class="col position-relative mb-4 text-center">
          <app-price-card
            [viewOnly]="viewOnly"
            [showShortDescription]="showShortDescription"
            [showInfoLine]="showInfoLine"
            [showFeatures]="appAlertPriceCardFeatureText ? true : showFeatures"
            [buttonLabel]="buttonLabel"
            [hidePrices]="hidePrices"
            [disabled]="disabled"
            [showPeachBanner]="showPeachBanner"
            [hideIcon]="hideIcons"
            [hasBuyNow]="hasBuyNow"
            [hasOrangeBorder]="showPremiumCardColoredBorder"
            [planId]="pricingPlans.identiAlertAnnual"
            [monthlyPlanId]="pricingPlans.identiAlertMonthly"
            [userCurrentProductType]="userCurrentProductType"
            [highlighted]="false"
            imageUri="/assets/images/pricingTable/identialert.svg"
            planTitle="{{ plan2Name }}"
            planShortSubtitle="Everything from {{ plan1Name }}"
            planLongSubtitle="For less than {{ plan2DailyPrice }} per day, get everything from {{ plan1Name }}"
            yearlyPrice="{{ plan2YearlyPrice }}"
            monthlyPrice="{{ plan2MonthlyPrice }}"
            priceNote="(12 month contract)"
            [features]="appAlertPriceCardFeatureText ? appAlertPriceCardFeatureText : getFeaturesFor(planFeatureService.plan2Name)"
            [descriptionList]="appAlertPriceCardFeatureText"
            [shortDescriptionList]="plan2BenefitsShort"
            [description]="appAlertPriceCardFeatureText ? '' : 'The fastest way to find your missing pet. A 24/7 network of pet finders - with alerts sent to every vet, warden, rescue centre, police and ' + brandName + ' customers in your area.'"
            (onSelect)="select($event)"
            (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIALERT)">
          </app-price-card>
        </div>
      </ng-container>

      <!-- main plan card desktop view -->
      <app-main-plan-card *ngIf="identiAlertAvailable && showWideIdentiAlertCard"
        class="main-plan-card mb-4 identialert-desktopview" [content]="mainPlanContent" [hideIcon]="hideIcons"
        [userCurrentProductType]="userCurrentProductType" [user]="user" [petName]="petName" [petType]="petType"
        [thereIsOnlyOneCat]="thereIsOnlyOneCat" [isOutdoors]="isOutdoors">
      </app-main-plan-card>

      <!--identi Smart-tag-->
      <ng-container *appFeatureFlag="'isIdentiSmartTagPlanAvailable'">
        <div *ngIf="user.productType !== 6 && smartTagSubAvailable" class="col mb-4 text-center">
          <app-price-card
            [viewOnly]="viewOnly"
            [showShortDescription]="showShortDescription"
            [showInfoLine]="showInfoLine"
            [showFeatures]="showFeatures"
            [buttonLabel]="buttonLabel"
            [hidePrices]="hidePrices"
            [disabled]="disabled"
            [hideIcon]="true"
            [planId]="pricingPlans.smartTagSubscription"
            [userCurrentProductType]="userCurrentProductType"
            [hasBuyNow]="hasBuyNow"
            [showPeachBanner]="showPeachBanner"
            [highlighted]="false"
            [hidePlusFromSubtitle]="true"
            planTitle="{{ planFeatureService.plan3Name }}"
            planLongSubtitle="Faster reunification than with a microchip alone."
            [yearlyPrice]="plan3YearlyPrice"
            [features]="getFeaturesFor(planFeatureService.plan3Name)"
            [shortDescriptionList]="plan3BenefitsShort"
            [description]="'Real time pet location tracking Award-winning activity monitoring to track exercise, distance &amp; rest'"
            (onSelect)="select($event)"
            (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.SMARTTAG)">
          </app-price-card>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *appFeatureFlag="'isIdentiSmartTagPlanAvailable'">
      <div *ngIf="user.productType === 6" class="col mb-4 text-center">
        <app-price-card
          planTitle="{{ plan3Name }}"
          buttonLabel="Request tags"
          [oneOffPrice]="smartTagPrice"
          [showButton]="true"
          [showSmartTagInfo]="true"
          [hideIcon]="true"
          [hidePrices]="false"
          [showShortDescription]="false"
          [showFeatures]="false"
          [showInfoLine]="showInfoLine"
          [showBestSeller]="false"
          [hasBuyNow]="false"
          (onSelect)="select('smartTag')"
          (onNavigateToProductPage)="onNavigateToProductPage.emit(PricingTableSubTypes.SMARTTAG)">
        </app-price-card>
      </div>
    </ng-container>

    <!-- <app-transfer-pet-card class="row-cols-3"></app-transfer-pet-card> -->
  </div>
</div>
